/**
 * Textos de Compras (`es`): tall «estats» de les millores de Compres (OBR-190 / OBR-181 / OBR-117). Tall propi: no es toca `es.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 *
 * OBR-190, estado «Pendiente de envío» del pedido de compra: las etiquetas del estado viven en
 * `backoffice.purchaseOrderStatus` (en `es.ts`); aquí están los textos NUEVOS que lo acompañan.
 */

export const estatsEs = {
  'backoffice.purchaseOrderDispatch': {
    receptionBlockedHint:
      'Todavía no has enviado este pedido al proveedor. Envíalo o márcalo como enviado antes de registrar su recepción.',
    draftNotVisibleToPlanta:
      'Este pedido todavía es un borrador y no aparece en la recepción de la app de planta. Confírmalo y envíalo al proveedor para que el operario pueda recibirlo.',
    pendingNotVisibleToPlanta:
      'Este pedido está confirmado pero todavía no se ha enviado al proveedor, por eso no aparece en la recepción de la app de planta ni se puede recepcionar. Envíalo o márcalo como enviado.',
    // El formulari d'edició d'una comanda que ja no és un esborrany (enllaç directe: el detall n'amaga el botó).
    notEditable:
      'Este pedido ya no se puede editar: solo se pueden cambiar los pedidos en curso (borradores).',
    skip_not_sent_one: '{{count}} todavía no se ha enviado al proveedor (si ya no hace falta, se cancela)',
    skip_not_sent_other: '{{count}} todavía no se han enviado al proveedor (si ya no hace falta, se cancelan)',
  },
} as const;
